import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

import { roleToPath } from '../constants/constant';

const PublicRoute = () => {
    const { user } = useSelector((state) => state.auth);

    const isAuthenticated = !!user;

    // ✅ Redirect to role-based dashboard if already logged in
    if (isAuthenticated && user.role) {
        return <Navigate to={roleToPath[user.role] || "/unauthorized"} replace />;
    }

    // ✅ Else render login/public content
    return <Outlet />;
}

export default PublicRoute;